export const SET_MESSENGER_SCROLL_BOTTOM = 'SET_MESSENGER_SCROLL_BOTTOM'

interface SetNeedScrollBottomAction {
  type: typeof SET_MESSENGER_SCROLL_BOTTOM
  value: boolean
}

export type MessengerScrollActionTypes = SetNeedScrollBottomAction
